import React, { useState } from 'react'
import {BiSearchAlt} from 'react-icons/bi';
import {useGlobalContext} from '../../Utils/ContextApi';
import {useNavigate, useParams} from 'react-router-dom';
import {fetchData} from '../../Utils/FetchData'
import './form.css'

function Form() {
    const navigate = useNavigate()
    const {name} = useParams()
    const [input, setInput] = React.useState('');
    const {movieData, setMovieData, searchMovie, setSearchMovie, setSearchBar} = useGlobalContext()
   
    
    const handle = async (e) => {
        e.preventDefault()
        if(input){
            const moviesData = await fetchData(`https://api.themoviedb.org/3/search/movie?api_key=f1495476b28b6efe4e4d6d815c2eb1e9&query=${input}`);

            console.log(moviesData)

            const movies = moviesData.filter((movie)=>{
                return movie.original_title.toLowerCase().includes(input)
            })
            setSearchMovie(movies)
            setInput('')
        }
        navigate(`/search/${input}`)
    }
    
  return (
    <div className='form-container'>
    <form className='form' onSubmit={handle}>
        <input 
            type='text'
            placeholder='Enter key words'
            name={input}
            value={input}
            onChange={(e) => setInput(e.target.value)}
        />
        <button style={{cursor:'pointer'}}><BiSearchAlt /></button>
    </form>
</div>
  )
}

export default Form